import React from 'react';
import Table from '../../common/TableOverView';
import { connect } from 'react-redux';
import { changeSortState, REDUCER_NAME } from '../reducer';
import Const from './Const';

const getDataFromRedux = state =>
  state[REDUCER_NAME].listObjectTopBreakoutDataByTicker;

function TableOverViewBreakOut(props) {
  const { listId, isLoading, sortState, changeSortState } = props;
  return (
    <Table
      sortState={sortState}
      onSort={changeSortState}
      isLoading={isLoading}
      listId={listId}
      resizable={true}
      columnDraggable={false}
      rowDraggable={false}
      getDataFromRedux={getDataFromRedux}
      hideColumns={Const.listHideColumn}
      listColumns={Const.listColumn}
      i18nTitleKey="topBreakout.overview.overviewHeader"
    />
  );
}

const mapStateToProps = state => {
  return {
    listId: state[REDUCER_NAME].listTopBreakoutDataTicker,
    isLoading: state[REDUCER_NAME].isLoading,
    sortState: state[REDUCER_NAME].sortState,
  };
};

const mapDispatchToProps = {
  changeSortState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TableOverViewBreakOut);
